import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '@context';


const AlertAndRedirect = ({ message, to }) => {

    useEffect(() => {
        alert(message);
    }, [message]);

    return <Navigate to={to} replace />;
};
const ProtectedRoute = ({ children, roles }) => {
    const { auth, isLoading  } = useContext(AuthContext);

    if (isLoading) return <div style={{textAlign:'center'}}>Loading...</div>;


    if (!auth.isAuthenticated) {
        return <AlertAndRedirect message="로그인이 필요합니다." to="/main" />;
    }

    if (roles && !roles.includes(auth.role)) {
        return <AlertAndRedirect message="권한이 없습니다" to="/main" />;
    }

    return children;
};

export default ProtectedRoute;
